import {
    GET_FUEL_VENDOR_ACCOUNT,
    GET_FUEL_VENDOR_NAMES,
    TOGGLE_FUEL_VENDOR_NAMES_LOADED,
    UPDATE_FUEL_VENDOR_ACCOUNT,
    SAVE_FUEL_VENDOR,
    TOGGLE_DUPLICATE_FUEL_VENDOR,
    UPDATE_CREATED_FUEL_ID,
    TOGGLE_FUEL_DETAILS_LOADED,
    DISCARD_FUEL_CHANGES,
    DISABLE_INTERACTIVE_FIELD,
    DISABLE_SAVE_BUTTON,
    CLOSE_SNACKBAR,
    DISPLAY_SNACKBAR,
    SET_SORT_ORDER,
    SET_SORT_FIELD,
    CLEAR_FUEL_VENDOR,
    GET_FUEL_VENDOR_ACCOUNTS,
    DELETE_FUEL_VENDOR_ACCOUNT,
    RESET_FUEL_VENDOR_ACCOUNT,
    TOGGLE_EDIT_DETAILS,
    TOGGLE_FUEL_SPINNER,
    TOGGLE_SUMMARY_SPINNER,
    SET_PREVIOUS_SELECTED_FUEL_ACCOUNTS,
    UNSET_PREVIOUS_SELECTED_FUEL_ACCOUNTS,
    SET_SELECTED_FUEL_ACCOUNTS,
    RESET_PAGE_SIZE
} from '../actions/types';
import { updateObject } from '../utility';

const initialState = {
    fuelVendorAccount: {},
    updatedFuelVendorAccount: {},
    fuelVendorNames: [],
    isFuelVendorNamesLoaded: false,
    isDuplicateFuelVendor: false,
    createdFuelVendorID: '',
    isFuelVendorDetailsLoaded: false,
    discardChanges: false,
    disableInteractiveField: true,
    showSpinner: false,
    showSummarySpinner: false,
    disableSaveButton: true,
    fuelVendorAccounts: [],
    selectedFuelAccounts: [],
    prevSelectedFuelAccounts: [],
    page: 1,
    pageSize: 10,
    sortOrder: 'asc',
    sortField: 'account_code',
    totalElements: 0,
    snackBarOptions: {
        showSnackbar: false,
        message: '',
        variant: ''
    },
    currentOperation: '',
    disableOtherOperation: false,
    editDetails: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_FUEL_VENDOR_ACCOUNT:
            return updateObject(state, {
                fuelVendorAccount: action.payload,
                updatedFuelVendorAccount: action.payload
            });
        case GET_FUEL_VENDOR_NAMES:
            return updateObject(state, { fuelVendorNames: action.payload });
        case TOGGLE_FUEL_VENDOR_NAMES_LOADED:
            return updateObject(state, { isFuelVendorNamesLoaded: action.payload });
        case UPDATE_FUEL_VENDOR_ACCOUNT:
            return updateObject(state, { updatedFuelVendorAccount: action.payload });
        case SAVE_FUEL_VENDOR:
            return updateObject(state, { fuelVendorAccount: action.payload });
        case TOGGLE_DUPLICATE_FUEL_VENDOR:
            return updateObject(state, { isDuplicateFuelVendor: action.payload });
        case UPDATE_CREATED_FUEL_ID:
            return updateObject(state, { createdFuelVendorID: action.payload });
        case TOGGLE_FUEL_DETAILS_LOADED:
            return updateObject(state, { isFuelVendorDetailsLoaded: action.payload });
        case TOGGLE_FUEL_SPINNER:
            return updateObject(state, { showSpinner: action.payload });
        case TOGGLE_SUMMARY_SPINNER:
            return updateObject(state, { showSummarySpinner: action.payload });
        case DISCARD_FUEL_CHANGES:
            return updateObject(state, { discardChanges: action.payload });
        case DISABLE_INTERACTIVE_FIELD:
            return updateObject(state, { disableInteractiveField: action.payload });
        case DISABLE_SAVE_BUTTON:
            return updateObject(state, { disableSaveButton: action.payload });
        case SET_SORT_ORDER:
            return updateObject(state, { sortOrder: action.payload });
        case SET_SORT_FIELD:
            return updateObject(state, { sortField: action.payload });
        case GET_FUEL_VENDOR_ACCOUNTS:
            const content = action.payload.content;
            const page = action.payload.page;
            const totalElements = action.payload.totalElements;
            const pageSize = action.payload.size;
            return updateObject(state, {
                fuelVendorAccounts: [...content],
                page: page,
                totalElements: totalElements,
                pageSize: pageSize
            });
        case CLEAR_FUEL_VENDOR:
            return updateObject(state, {
                fuelVendorAccounts: action.payload
            });
        case DISPLAY_SNACKBAR:
            return updateObject(state, {
                snackBarOptions: {
                    showSnackbar: action.payload[0],
                    message: action.payload[1],
                    variant: action.payload[2]
                }
            });
        case DELETE_FUEL_VENDOR_ACCOUNT:
            return updateObject(state, {
                snackBarOptions: {
                    showSnackbar: action.payload,
                    message: 'Selected account(s) deleted successfully',
                    variant: 'success'
                }
            });
        case CLOSE_SNACKBAR:
            return updateObject(state, {
                snackBarOptions: {
                    showSnackbar: false,
                    message: '',
                    variant: ''
                }
            });
        case SET_SELECTED_FUEL_ACCOUNTS:
            return updateObject(state, { selectedFuelAccounts: [...action.payload] });
        case SET_PREVIOUS_SELECTED_FUEL_ACCOUNTS:
            let prevSelectedFuelAccounts = [...state.prevSelectedFuelAccounts];
            if (prevSelectedFuelAccounts.length > 0) {
                const uniqueSelectedFuelAccounts = state.selectedFuelAccounts.filter(
                    ({ id: id1 }) =>
                        !state.prevSelectedFuelAccounts.some(({ id: id2 }) => id2 === id1)
                );
                prevSelectedFuelAccounts.push(...uniqueSelectedFuelAccounts);
            } else {
                prevSelectedFuelAccounts = [...state.selectedFuelAccounts];
            }
            return updateObject(state, {
                prevSelectedFuelAccounts: [...prevSelectedFuelAccounts],
                selectedFuelAccounts: [...state.prevSelectedFuelAccounts]
            });
        case UNSET_PREVIOUS_SELECTED_FUEL_ACCOUNTS:
            const accountIds = action.payload;
            const flag = action.flag;
            let updatedPrevSelectedFuelAccount = [];
            let currentSelectedFuelAccounts = [];
            if (flag === 'all') {
                updatedPrevSelectedFuelAccount = state.prevSelectedFuelAccounts.filter(
                    ({ id: id1 }) => !state.fuelVendorAccounts.some(({ id: id2 }) => id2 === id1)
                );
            } else {
                updatedPrevSelectedFuelAccount = state.prevSelectedFuelAccounts.filter(
                    ({ id: id1 }) => !accountIds.some((id2) => id2 === id1)
                );
                currentSelectedFuelAccounts = [...state.selectedFuelAccounts];
            }
            return updateObject(state, {
                prevSelectedFuelAccounts: [...updatedPrevSelectedFuelAccount],
                selectedFuelAccounts: [...currentSelectedFuelAccounts]
            });
        case RESET_FUEL_VENDOR_ACCOUNT:
            return updateObject(state, {
                fuelVendorAccount: action.payload,
                updatedFuelVendorAccount: action.payload
            });
        case RESET_PAGE_SIZE:
            return updateObject(state, {
                page: 0,
                pageSize: 5,
                totalElements: 0
            });
        case TOGGLE_EDIT_DETAILS:
            return updateObject(state, { editDetails: action.payload });
        default:
            return state;
    }
};
